module.exports = __webpack_public_path__ + "img/1.f4752fa3.jpg";